import React from 'react';
import styled from '@xstyled/styled-components';
import DragIcon from '~/assets/button/drag.svg';

const DragHandleButton = styled.button`
  cursor: grab;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 1;
  }

  &:active {
    cursor: grabbing;
  }

  svg {
    width: 22px;
    height: 22px;
    flex-shrink: 0;
  }
`;

export const DragHandle: React.FC = () => (
  <DragHandleButton
    type="button"
    aria-label="Drag to reorder tab"
    data-drag-handle
    onMouseDown={e => e.stopPropagation()}
  >
    <DragIcon />
  </DragHandleButton>
);
